<template>
  <v-app>
    <v-content>
      <v-dialog value="true"
                persistent
                max-width="800px">
        <SignUpForm />
      </v-dialog>
      <Map id="map"/>
    </v-content>
  </v-app>
</template>

<script>
import SignUpForm from '@/components/SignUpForm'
import Map from '@/components/Map'

export default {
  name: 'SignUp',
  components: {SignUpForm, Map},
  data: function() {
    return {
    }
  },
}
</script>

<style>
</style>

<style scoped>
</style>
